import type { EditorSDK } from '../types'

export interface BiDefaults {
  esi?: string
  site_id?: string
  editor_working_mode?: string
  _appId?: string
  ver?: string
}

export const getBiDefaults = async ({
  editorSdkProxy,
  appVersion,
}: {
  editorSdkProxy: EditorSDK
  appVersion?: string
}): Promise<BiDefaults> => {
  const [esi, siteId, editorWorkingMode, blocksAppDefId] = await Promise.all([
    editorSdkProxy.info.getEditorSessionId(),
    editorSdkProxy.info.getSiteId(),
    editorSdkProxy.info.getEditorMode(),
    editorSdkProxy.appBuilder?.appInfo?.getAppDefId?.(),
  ])

  return {
    esi,
    site_id: siteId,
    editor_working_mode: editorWorkingMode,
    _appId: blocksAppDefId,
    ver: appVersion,
  }
}
